import { ReactNode } from "react";
import { SiteShell } from "@jambushrushti/site/SiteLayout";

interface LayoutProps {
  children: ReactNode;
}

/**
 * Pages that are not part of the new design yet (research tools, legal pages, auth, scholars…)
 * still wrap themselves in <Layout>; they now get the new site header and footer.
 */
export function Layout({ children }: LayoutProps) {
  return (
    <SiteShell>
      <div className="jbs-legacy">{children}</div>
    </SiteShell>
  );
}
